import React from 'react'
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb'
import BriefHistory from '../../Components/BriefHistory/BriefHistory'
import WhyBankWithUsComponents from '../../Components/WhyBankWithUsComponent/WhyBankWithUsComponent';
// import BackgroundBrundcrumb from "../../assets/images/IZB/BackgroundBrundcrumb.png";
import { useEffect } from 'react';


const WhyBankWithUs = () => {
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";
const img = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Branch-Network.jpeg";

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
    <Breadcrumb Heading="Why Bank With Us" img={BackgroundBrundcrumb}/>
    <BriefHistory heading="Branch Networks" content="Since the formation of Indo Zambia Bank in 1984 we have continued promoting bank facilities in support of economic development across the entire landscape with 35 in all 10 provincial centres of Zambia." image={img} />
    
    <WhyBankWithUsComponents/>
    </>
  )
}

export default WhyBankWithUs